import { FC } from 'react';

import { useRemoteStorageCredentialsUpdaterPresenter } from './RemoteStorageCredentialsUpdater.presenter';

interface IRemoteStorageCredentialsUpdaterProps {
  isAuthenticated: boolean;
}

export const RemoteStorageCredentialsUpdater: FC<IRemoteStorageCredentialsUpdaterProps> = (
  props
) => {
  useRemoteStorageCredentialsUpdaterPresenter({ isAuthenticated: props.isAuthenticated });

  return null;
};
